import React from "react";

export const TidyUpIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      {/* Row 1 */}
      <circle cx="3.333" cy="3.333" r="1" fill="#1A2547" />
      <circle cx="8" cy="3.333" r="1" fill="#1A2547" />
      <circle cx="12.667" cy="3.333" r="1" fill="#1A2547" />

      {/* Row 2 */}
      <circle cx="3.333" cy="8" r="1" fill="#1A2547" />
      <circle cx="8" cy="8" r="1" fill="#1A2547" />
      <circle cx="12.667" cy="8" r="1" fill="#1A2547" />

      {/* Row 3 */}
      <circle cx="3.333" cy="12.667" r="1" fill="#1A2547" />
      <circle cx="8" cy="12.667" r="1" fill="#1A2547" />
      <circle cx="12.667" cy="12.667" r="1" fill="#1A2547" />
    </svg>
  );
};
